/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ input: NonNullable<unknown>, output: NonNullable<unknown> }} Read_Along_Ai_TokensInputs */

const en_read_along_ai_tokens = /** @type {(inputs: Read_Along_Ai_TokensInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tokens: ${i?.input} input · ${i?.output} output`)
};

const es_read_along_ai_tokens = /** @type {(inputs: Read_Along_Ai_TokensInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tokens: ${i?.input} de entrada · ${i?.output} de salida`)
};

/**
* | output |
* | --- |
* | "Tokens: {input} input · {output} output" |
*
* @param {Read_Along_Ai_TokensInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_tokens = /** @type {((inputs: Read_Along_Ai_TokensInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_TokensInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_tokens(inputs)
	return en_read_along_ai_tokens(inputs)
});